import type { RbacRole as Source } from '../../state/api/axilon-v2-api.generated'
import { pinEnum } from '../utils/pin-enum'

export const RbacRole = {
  Developer: 'developer',
  MachineAdmin: 'machine_admin',
  GlobalAdmin: 'global_admin',
  Operator: 'operator',
  Viewer: 'viewer',
  Engineer: 'engineer',
  Admin: 'admin',
  ServiceAccount: 'service_account',
  Maintenance: 'maintenance',
  IngestUploader: 'ingest_uploader',
  DevopsSync: 'devops_sync'
} as const
export type RbacRole = (typeof RbacRole)[keyof typeof RbacRole]

pinEnum<RbacRole, Source>()

export const RbacRoleLabel: Record<RbacRole, string> = {
  [RbacRole.Developer]: 'Developer',
  [RbacRole.MachineAdmin]: 'Machine Admin',
  [RbacRole.GlobalAdmin]: 'Global Admin',
  [RbacRole.Operator]: 'Operator',
  [RbacRole.Viewer]: 'Viewer',
  [RbacRole.Engineer]: 'Engineer',
  [RbacRole.Admin]: 'Admin',
  [RbacRole.ServiceAccount]: 'Service Account',
  [RbacRole.Maintenance]: 'Maintenance',
  [RbacRole.IngestUploader]: 'Ingest Uploader',
  [RbacRole.DevopsSync]: 'DevOps Sync'
}
